__turbopack_context__.v({
  "rrss": "Rrss-module__kM5Noq__rrss",
});
